import script from "./InterestedUsersManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InterestedUsersManagement.vue?vue&type=script&setup=true&lang=js"

import "./InterestedUsersManagement.vue?vue&type=style&index=0&id=03253b86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03253b86"]])

export default __exports__